export default {
  baseUrlDev: "https://webapi.aamuyeed.com/",
  baseUrl: "https://webapi.aamuyeed.com/",
  baseUrlLocal: "https://webapi.aamuyeed.com/",
};
